export const type = {
  nouns: "'Londrina Solid', cursive",
  serif: "'Libre Baskerville', serif",
  mono: "'Roboto Mono', monospace",
};
